import React from 'react';

import { useSearchParams } from '@/hooks/useSearchParams';

import {
    mapUrlParamsToQuery,
    mapUrlParamsToSort,
    urlParamFilterNames,
} from './LocationSearchContext';

const LocationFilterContext = React.createContext({});

export const LocationFilterContextProvider = ({ children }) => {
    const [openPanel, setOpenPanel] = React.useState(false);
    const [tempFilter, setTempFilter] = React.useState({});

    const searchParams = useSearchParams();

    const searchParamToTempFilter = React.useCallback(() => {
        const newTempFilter = {};

        const singleValueNames = [
            ...Object.keys(mapUrlParamsToQuery),
            ...Object.keys(mapUrlParamsToSort),
        ];

        for (const name of singleValueNames) {
            const value = searchParams.get(name);
            if (value) {
                newTempFilter[name] = value;
            }
        }

        for (const name of urlParamFilterNames) {
            const value = searchParams.getAll(name)?.filter(Boolean);
            if (value && value.length > 0) {
                newTempFilter[name] = value;
            }
        }

        setTempFilter(newTempFilter);
    }, [searchParams]);

    React.useEffect(() => {
        searchParamToTempFilter();
    }, [searchParamToTempFilter]);

    return (
        <LocationFilterContext.Provider
            value={{
                openPanel,
                setOpenPanel,
                tempFilter,
                setTempFilter,
                searchParamToTempFilter,
            }}
        >
            {children}
        </LocationFilterContext.Provider>
    );
};

export const useLocationFilterContext = () => {
    const context = React.useContext(LocationFilterContext);

    if (context == null) {
        throw new Error(`'useLocationFilterContext' needs to be within 'LocationFilterContext'`);
    }

    return context;
};
